import { CONGA } from '@/api/utils/endpoints'
import axios from '@/plugins/axios'

export const getConga = () => axios.get(CONGA)
export const getHealth = () => axios.get('/v1/health')
